import { render, staticRenderFns } from "./editPlan.vue?vue&type=template&id=a1db023a&scoped=true"
import script from "./editPlan.vue?vue&type=script&lang=js"
export * from "./editPlan.vue?vue&type=script&lang=js"
import style0 from "./editPlan.vue?vue&type=style&index=0&id=a1db023a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1db023a",
  null
  
)

export default component.exports